/* eslint-disable */
export const fileToBase64 = (file) => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = (event) => resolve(event.target.result)
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}



// WEBPACK FOOTER //
// ./src/app/_default/utils/fileToBase64.js